import React from "react";
import WorkerSupport from "./WorkerSupport";

export default function SupportPage() {
    return (
        <div className="animate-fade-in">
            <WorkerSupport />
        </div>
    );
}
